import { render, staticRenderFns } from "./AdminCesionHistorial.vue?vue&type=template&id=04502619"
import script from "./AdminCesionHistorial.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCesionHistorial.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports